<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo4.jpg" style="background-image: url('assets/img/fondo4.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            Plan Maestro del Centro Histórico de Cusco
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section mt-80 mt-md-60 mt-sm-40 mb-30" style="background-image: url('/assets/img/fondo-plan-maestro.png'); background-size: cover; background-position: center;">
  <div class="container" >
    <div class="row" >
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap">
          <h2>¿Que es el Plan Maestro?</h2>
          <p class="mb-0" style="font-weight: 300">
            El plan maestro es un documento donde la Municipalidad del Cusco
            organiza una serie de pautas con determinados objetivos e hitos que
            conllevan una planificación a largo plazo del Centro Histórico del
            Cusco. Directrices que pueden hablarnos de diseño y la organización
            proyectada del Cusco. Este viene a ser el plan urbanístico de
            nuestra ciudad.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 my-auto text-center">
        <h3 style="font-size: 18px; margin-bottom: 30px" class="text-center">
          ACTUALIZACIÓN PLAN MAESTRO CENTRO HISTÓRICO CUSCO 2018 - 2028
        </h3>
        <div class="row">
          <div class="col-md-12 text-center">
            <p>
              <img src="assets/img/inma_icon_7.png" alt="" /> Versión Resumida
            </p>
          </div>
        </div>
        <iframe
          style="width: 95%; height: 600px"
          src="http://online.anyflip.com/rhspq/nkhz/"
          seamless="seamless"
          scrolling="no"
          frameborder="0"
          allowtransparency="true"
          allowfullscreen="true"
        ></iframe>
      </div>
    </div>
  </div>
</section>
<section class="latest-blog-area-wrapper bg-offwhite pt-120 pt-md-80 pt-sm-60 pb-60 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-tomos.png'); background-size: cover; background-position: center;">
  <div class="container-fluid p-lg-0 p-xl-0">
    <div class="row no-gutters">
      <div class="col-lg-4 m-auto text-center">
        <div class="section-title-wrap layout--2">
          <h3 >Tomos del Plan Maestro del Centro Histórico</h3>
          <p class="mb-0" >
            El plan maestro del Centro Histórico del Cusco se divide en dos
            tomos, los cuales mostraremos a continuación.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="call-to-action-wrapper">
  <div class="call-to-action-content-wrap d-md-flex">
    <!-- Single Call to Action Start -->
    <div class="single-call-action-wrap text-center text-lg-left">
      <figure class="call-action-thumb">
        <img src="assets/img/tomo1.png" alt="Call Action"/>
      </figure>
      <div class="call-action-info">
        <h2>Tomo I</h2>
        <p>
          Actualización del Plan Maestro del Centro Histórico del Cusco 2018 - 2028,
          elavorado por la Municipalidad del Cusco en coordinación con la población en
          general y con todas aquellas instituciones y organizaciones involucradas con
          la protección del patrimonio cultural de nuestra ciudad.
        </p>
        <a href="/tomo-uno" class="btn btn-bordered">Ver información</a>
      </div>
    </div>
    <!-- Single Call to Action End --><!-- Single Call to Action Start -->
    <div class="single-call-action-wrap text-center text-lg-left">
      <figure class="call-action-thumb">
        <img src="assets/img/tomo2.png" alt="Call Action" />
      </figure>
      <div class="call-action-info">
        <h2>Tomo II</h2>
        <p>
          Actualización del Plan Maestro del Centro Histórico del Cusco 2018 - 2028,
          elavorado por la Municipalidad del Cusco en coordinación con la población en
          general y con todas aquellas instituciones y organizaciones involucradas con
          la protección del patrimonio cultural de nuestra ciudad.
        </p>
        <a href="/tomo-dos" class="btn btn-bordered">Ver información</a>
      </div>
    </div>
    <!-- Single Call to Action End -->
  </div>
</div>




